module.exports = {"SELECTED_STORE":"SELECTEER WINKEL","SELECT_USER":"SELECTEER GEBRUIKER","SELECTED_USER":"GESELECTEERDE GEBRUIKER","USER_NOT_FOUND":"GEBRUIKER NIET GEVONDEN","SELECT_STORE":"SELECTEER WINKEL","STORE_NOT_FOUND":"GEEN WINKEL GEVONDEN","CLEAR_SEARCH":"WIS ZOEKACTIES","FIND_USER":"VIND GEBRUIKER","SEARCHED_STORE_NOT_FOUND":"GEEN WINKELS GEVONDEN DIE AAN DE ZOEKACTIE VOLDOEN","LAST_ENTERED_STORE":"LAATST BINNENGEKOMEN WINKEL"}


//////////////////
// WEBPACK FOOTER
// ./src/plugins/tfs/platformConfigs/staticTextMaps/signIn.json
// module id = 196
// module chunks = 1